import React, { useContext } from 'react'
import { Button, Container, Navbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSignOutAlt } from 'react-icons/fa';
import { Outlet } from 'react-router'
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthProvider';
import "./Main.css";

export const Main = () => {

    const { user, logOut } = useContext(AuthContext);


    return (
        <>
            <Navbar className='rt-main px-5 '>
                {/* <Container>s */}
                    <Navbar.Brand >
                        <Link className="no-decoration" to="/home">
                            <img src="/newlogo-removebg.png" alt="logo" className='brand-logo' />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text>
                            <span className='m-3'>{user.displayName}</span>
                        </Navbar.Text>
                        <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id={`tooltip-${user.displayName}`}>Logout</Tooltip>}
                        >
                        <Button variant="light" className='logout-btn' onClick={logOut}><FaSignOutAlt /></Button>
                    </OverlayTrigger>
                    </Navbar.Collapse>
                {/* </Container> */}
            </Navbar>

            {/* <Container> */}

                <Outlet sm={5}/>
            {/* </Container> */}
        </>
    )
}
